import styled from "styled-components";

export const TextAreaLabel = styled.label`
  position: relative;

  & > span {
    color: rgba(0, 0, 0, 0.56);
    font-family: "Noto Sans";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    background-color: #fff;
    position: absolute;
    padding: 0 4px;
    left: 24px;
    top: -8px;
  }

  & > textarea {
    display: block;
    width: 100%;
    min-height: 180px;
    border-radius: 8px;
    border: 1px solid #9d9d9d;
    background: #fff;
    resize: none;
    outline: none;
    padding: 16px;

    &:focus {
      outline: none;
    }
  }
`;
